export default __webpack_public_path__ + "static/psuaa-3216097d4a7b929a8823996cb116a928.png";